var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{staticClass:"w-full profile-cover-h object-cover",attrs:{"src":require("@/views/e-learning/img/profile/cover.jpg"),"alt":"profilecover"}})])])
}]

export { render, staticRenderFns }